export const PROVIDER_DELETE_PREVIEW_LABELS: Record<string, string> = {
  linked_users: 'Comptes utilisateurs rattachés',
  announcements: 'Annonces liées au partenaire (dont miroirs FO-CONTACT)',
  announcements_active: 'Annonces classiques actives (hors miroirs)',
  announcement_images_on_disk: 'Images annonces classiques (fichiers sur le serveur)',
  found_objects: 'Objets trouvés (catalogue)',
  found_objects_active: 'Objets trouvés actifs (hors « disposé »)',
  found_object_images_on_disk: 'Images objets trouvés (fichiers sur le serveur)',
  conversations: 'Conversations',
  messages: 'Messages',
  matchings: 'Matchings',
  provider_items: 'Lieux / points',
  provider_events: 'Événements',
  has_logo: 'Logo (fichier sur le serveur)',
};
